import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExplosion = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M29.659 28.2415L23.8576 21.6918C23.4003 21.1756 22.5507 21.562 22.6391 22.2459L23.9993 32.7406C24.0597 33.2073 23.6519 33.5997 23.1882 33.5208L11.5698 31.5515C10.8759 31.4337 10.4616 32.2983 10.9882 32.7655L26.8861 46.8723C27.0598 47.0266 27.1457 47.2567 27.1157 47.4873L26.1298 54.9795C26.0465 55.6114 26.7823 56.0168 27.2719 55.6084L33.0894 50.7609C33.3335 50.5573 33.6844 50.5438 33.9435 50.728L42.5748 56.8659C43.1723 57.2907 43.938 56.6278 43.6031 55.9753L40.4048 49.7476C40.2326 49.4126 40.3564 49.0018 40.6849 48.8171L52.3102 42.2909C52.9322 41.9419 52.6946 40.995 51.9818 40.9805L42.9661 40.7963C42.5288 40.7873 42.2064 40.384 42.2947 39.9552L48.8994 7.84406C49.0471 7.12525 48.1306 6.69246 47.6694 7.26302L30.7273 28.2175C30.4552 28.554 29.9455 28.5655 29.659 28.2415Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExplosion);
export default ForwardRef;
